import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { Companies } from '../../models/companies.model';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-account',
  templateUrl: './company-account.component.html',
  styleUrls: ['./company-account.component.scss']
})
export class CompanyAccountComponent implements OnInit {
  
  companies: Companies = new Companies({});
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  areaActivityList: any[] = [];
  isLoading: boolean = false;
  logoFile: any;
  logoPath: any;

  companyForm: FormGroup = new FormGroup({});
  

  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {
    if (usersService.getUserType() != 'entreprise') {
      this.router.navigate(['/not-found']);
    }
    
    this.companies = this.usersService.getCurrentUser();
  }

  ngOnInit() {
    this.loadCountries();
    this.areaActivityList = this.functionsService.getAreaActivitiesList();
    this.initForm();
  }

  initForm() {
    this.logoPath = this.companies.getLogo();
    this.companyForm = this.formBuilder.group({
      area_activity_id: [(this.companies.getAreaActivity() != null) ? this.companies.getAreaActivity()['id'] : '', Validators.required],
      name_creator: [(this.companies.getNameCreator() != null) ? this.companies.getNameCreator() : '', Validators.required],
      position_creator: [(this.companies.getPositionCreator() != null) ? this.companies.getPositionCreator() : '', Validators.required],
      name: [(this.companies.getName() != null) ? this.companies.getName() : '', Validators.required],
      website_link: [(this.companies.getWebsiteLink() != null) ? this.companies.getWebsiteLink() : ''],
      acronym: [(this.companies.getAcronym() != null) ? this.companies.getAcronym() : '', Validators.required],
      description: [(this.companies.getDescription() != null) ? this.companies.getDescription() : ''],
      phone_1: [(this.companies.getPhone1() != null) ? this.companies.getPhone1() : '', Validators.required],
      phone_2: [(this.companies.getPhone2() != null) ? this.companies.getPhone2() : ''],
      country: [(this.companies.getCountry() != null) ? this.companies.getCountry() : 'Benin', Validators.required],
      city: [(this.companies.getCity() != null) ? this.companies.getCity() : '', Validators.required],
      address: [(this.companies.getAddress() != null) ? this.companies.getAddress() : '', Validators.required],
      nb_person: [(this.companies.getNbPerson() != null) ? this.companies.getNbPerson() : '', Validators.required],
    });
  }

  onSubmitForm() {
    const formValue = this.companyForm.value;
    formValue['email'] = this.companies.getEmail();
    formValue['logo'] = this.logoFile;
    
    this.isLoading = true;
    this.httpService.editCompany(formValue).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCompany', JSON.stringify(data));
          this.isLoading = false;
          this.companies = this.usersService.getCurrentUser();
          this.initForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Vos informations ont été mises à jour.',
          }).then(() => {
            location.reload();
          });
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  async chooseLogo() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner votre Logo',
      input: 'file',
      inputAttributes: {
        'accept': 'image/png, image/jpeg',
        'aria-label': 'Cv selectionné'
      }
    });

    if (file) {
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type .PNG ou .JPEG'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.logoFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      this.countryData = data;
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();

      this.cityList = this.functionsService.findCitiesOfCountry('Benin', this.countryData);
    })
  }

  onChangeCountry(country: string) {
    this.cityList = this.functionsService.findCitiesOfCountry(country, this.countryData);
  }
}
